import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import Placeholder from '../Placeholder/Placeholder';

@inject('omaveroStore')
@observer
class VerottajaTili extends Component {
  render() {
    const { omaveroStore } = this.props;

    return (

      omaveroStore.verotilit ?
        <Select
          value={omaveroStore.selectedVerotili}
          onChange={omaveroStore.selectVerotili}
        //classes={{ root: "verottajatili-select" }} this doesn't work for some reason
        >
          {
            omaveroStore.verotilit.map(item =>
              <MenuItem
                key={item.VEROTILIID}
                value={item.VEROTILIID}
              >
                <Typography component={'span'} variant="body1">{item.PANKINNIMI}</Typography>
              </MenuItem>
            )
          }
        </Select> :

        <Placeholder size={6} />
    );
  }
}

export default VerottajaTili;
